import React, { useEffect, useState } from "react"
import AdPlacement from "../ui/Promotions/AdPlacement"
import ProductScrollableList from "../ui/ProductScrollableList"
import AppsIcons from "../ui/AppsIcons"
import { RootCategoriesGrid } from "../ui/Categories/CategoryGrids"
import RecentlyViewed from "../ui/RecentlyViewed"
import useT from "../hooks/useT"
import useAsync from "../hooks/useAsync"
import useSiteLanguage, { useCurrency } from "../hooks/useSiteLanguage"
import { GetHomepageData } from "../api"
import { usePageContext } from "vike-react/usePageContext"

function DownloadApps() {
  const t = useT()
  return (
    <section className="w-full flex flex-col items-center gap-5 bg-neutral py-12 px-4">
      <h2 className="m-0 text-[16px] md:text-[20px] lg:text-[24px] font-bold text-center">{t`Download our mobile app`}</h2>
      <AppsIcons />
    </section>
  )
}

/**
 * Storefront home: hero carousel (the "home-hero" ads placement), latest row (homepage data),
 * root categories, deferred promo banners + popular row, app CTAs.
 */
export default function HomePage() {
  const language = useSiteLanguage()
  const currency = useCurrency()
  const [showDeferred, setShowDeferred] = useState(false)
  const t = useT()
  // the first screen as the server fetched it (pages/homeSSR.js): shown with
  // the page, then refreshed by the browser's own fetches
  const seed = usePageContext().storefrontHome || null

  const { result: home } = useAsync(() => GetHomepageData({ language, currency }), [language, currency], { initial: seed?.home || null })

  useEffect(() => {
    const timer = setTimeout(() => setShowDeferred(true), 800)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="relative w-full flex flex-col">
      {/* the page's spots are Aldoo Ads placements (Admin → Ads → Placements) */}
      {/* the page's heading, for search engines and screen readers: the hero is a banner */}
      <h1 className="sr-only">{t`Aldoo – books, software and more`}</h1>
      <AdPlacement placement="home-hero" initial={seed?.placements?.["home-hero"] || null} />

      <div className="w-full max-w-w1_xl space-y-10 px-4 md:px-10 py-16 md:py-20 mx-auto">
        {/* Featured by Aldoo (the row takes its title from the category's name),
            in the order set for it (Admin → Store → Products → Category sorting) */}
        <div className="w-full">
          <ProductScrollableList placement="home" category="featured" sortBy="weight" itemsPerPage={10} />
        </div>

        <div className="w-full">
          <ProductScrollableList placement="home" category="latest" title={t`Latest`} products={home?.latestBooks} itemsPerPage={10} />
        </div>

        {/* Книги → Художествена литература (the row takes its title from the category's name) */}
        <div className="w-full">
          <ProductScrollableList placement="home" category="hudozhestvena-literatura" itemsPerPage={10} initial={seed?.rows?.["hudozhestvena-literatura"] || null} />
        </div>
        
        {/* Recently viewed — the row carries its own gutters, so with nothing to show it leaves no empty child (and no extra gap) in the column */}
        <RecentlyViewed className="w-full" />

        {/* <RootCategoriesGrid /> */}

        {showDeferred && (
          <div className="space-y-10">
            <AdPlacement placement="featured-4-soap-baronesse" />
            <div className="w-full pt-10">
              {/* Книги → Нехудожествена литература */}
              <ProductScrollableList placement="home" category="nehudozhestvena-literatura" itemsPerPage={10} className="mb-10" />
              <ProductScrollableList placement="home" category="popular" title={t`Popular`} itemsPerPage={10} />
            </div>

            <AdPlacement placement="simon-beckett" />
          </div>
        )}

        <ProductScrollableList placement="home" category="software" itemsPerPage={10} initial={seed?.rows?.software || null} />

        {/* <DownloadApps /> */}
      </div>
    </div>
  )
}
